import React, { useState, useEffect } from "react";

import Close from "../../../images/close-white.png";

function NICRejectMOdal(props) {

  const rejectNic = () => {
    props.handleRejectNIC();
  }

  return (
    <div
      className="modal fade"
      id="nicUnverifyModal"
      tabIndex="-1"
      aria-labelledby="nicUnverifyModalabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="nicUnverifyModalLabel">
              Are you sure?
            </h5>

            <img
              src={Close}
              alt="close"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              width="50px"
              style={{ cursor: "pointer" }}
              id="nicUnverifyModalClose"
            />
          </div>
          <div className="modal-body">
            <p style={{ marginBottom: 25 }}>
              Do you want to unverify this ID?
            </p>
          </div>


          <div className="modal-footer border-0 p-2">
            <button type="button" className="btn" data-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={rejectNic}
              style={{ width: 95 }}
              data-dismiss="modal"
            >
              Unverify
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NICRejectMOdal;
